// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckBox_root__2cztZ","check":"CheckBox_check__1z3AN","small":"CheckBox_small__2C4j3","checkbox":"CheckBox_checkbox__192Q4","text":"CheckBox_text__E5Wq_"};